import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { NotificationType } from './types'
import { RootState } from '../types'

export const state: NotificationType = {
  subscription: {},
  newNotifications: [],
  unreadNotificationsCount: 0
}

const namespaced = true

export const notificationsState: Module<NotificationType, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
